export const FBIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <defs>
        <filter
          id="Ellipse_52"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="fb" transform="translate(9.474 5.711)">
        <g
          transform="matrix(1, 0, 0, 1, -9.47, -5.71)"
          filter="url(#Ellipse_52)"
        >
          <circle
            id="Ellipse_52-2"
            data-name="Ellipse 52"
            cx="17"
            cy="17"
            r="17"
            transform="translate(9 6)"
            fill="#fff"
          />
        </g>
        <path
          id="Icon_awesome-facebook-f"
          data-name="Icon awesome-facebook-f"
          d="M11.989,12.671l.626-4.077H8.7V5.949a2.038,2.038,0,0,1,2.3-2.2H12.78V.275A21.687,21.687,0,0,0,9.623,0C6.4,0,4.3,1.953,4.3,5.487V8.594H.715v4.077H4.3v9.855H8.7V12.671Z"
          transform="translate(9.22 5.632)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
export const InstagramIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <defs>
        <filter
          id="Ellipse_52"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Insta" transform="translate(8.79 5.711)">
        <g
          transform="matrix(1, 0, 0, 1, -8.79, -5.71)"
          filter="url(#Ellipse_52)"
        >
          <circle
            id="Ellipse_52-2"
            data-name="Ellipse 52"
            cx="17"
            cy="17"
            r="17"
            transform="translate(9 6)"
            fill="#fff"
          />
        </g>
        <path
          id="Icon_awesome-instagram"
          data-name="Icon awesome-instagram"
          d="M9.861,5.8a5.055,5.055,0,1,0,5.055,5.055A5.047,5.047,0,0,0,9.861,5.8Zm0,8.342a3.287,3.287,0,1,1,3.287-3.287A3.293,3.293,0,0,1,9.861,14.14ZM16.3,5.591a1.179,1.179,0,1,1-1.179-1.179A1.176,1.176,0,0,1,16.3,5.591Zm3.348,1.2a5.835,5.835,0,0,0-1.593-4.131,5.873,5.873,0,0,0-4.131-1.593C12.3.971,7.419.971,5.791,1.064A5.865,5.865,0,0,0,1.66,2.652,5.854,5.854,0,0,0,.067,6.783c-.092,1.628-.092,6.507,0,8.135A5.835,5.835,0,0,0,1.66,19.05a5.881,5.881,0,0,0,4.131,1.593c1.628.092,6.507.092,8.135,0a5.835,5.835,0,0,0,4.131-1.593,5.873,5.873,0,0,0,1.593-4.131c.092-1.628.092-6.5,0-8.131Zm-2.1,9.877a3.327,3.327,0,0,1-1.874,1.874c-1.3.515-4.378.4-5.812.4s-4.518.114-5.812-.4a3.327,3.327,0,0,1-1.874-1.874c-.515-1.3-.4-4.378-.4-5.812s-.114-4.518.4-5.812A3.327,3.327,0,0,1,4.049,3.167c1.3-.515,4.378-.4,5.812-.4s4.518-.114,5.812.4a3.327,3.327,0,0,1,1.874,1.874c.515,1.3.4,4.378.4,5.812S18.062,15.372,17.547,16.665Z"
          transform="translate(6.879 6.041)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
export const InIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <defs>
        <filter
          id="Ellipse_52"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="in" transform="translate(9.104 5.711)">
        <g
          transform="matrix(1, 0, 0, 1, -9.1, -5.71)"
          filter="url(#Ellipse_52)"
        >
          <circle
            id="Ellipse_52-2"
            data-name="Ellipse 52"
            cx="17"
            cy="17"
            r="17"
            transform="translate(9 6)"
            fill="#fff"
          />
        </g>
        <path
          id="Icon_awesome-linkedin-in"
          data-name="Icon awesome-linkedin-in"
          d="M4.412,19.71H.326V6.551H4.412ZM2.367,4.756A2.378,2.378,0,1,1,4.733,2.367,2.387,2.387,0,0,1,2.367,4.756ZM19.706,19.71H15.629V13.3c0-1.527-.031-3.485-2.125-3.485-2.125,0-2.45,1.659-2.45,3.375V19.71H6.972V6.551h3.919v1.8h.057a4.294,4.294,0,0,1,3.866-2.125c4.136,0,4.9,2.723,4.9,6.261V19.71Z"
          transform="translate(7.884 7.04)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
export const TwitterIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <defs>
        <filter
          id="Ellipse_52"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="twitter" transform="translate(9.421 5.711)">
        <g
          transform="matrix(1, 0, 0, 1, -9.42, -5.71)"
          filter="url(#Ellipse_52)"
        >
          <circle
            id="Ellipse_52-2"
            data-name="Ellipse 52"
            cx="17"
            cy="17"
            r="17"
            transform="translate(9 6)"
            fill="#fff"
          />
        </g>
        <path
          id="Icon_awesome-twitter"
          data-name="Icon awesome-twitter"
          d="M20.211,6.062c.014.2.014.4.014.6A13.046,13.046,0,0,1,7.089,19.8,13.046,13.046,0,0,1,0,17.726a9.551,9.551,0,0,0,1.115.057A9.246,9.246,0,0,0,6.847,15.81a4.625,4.625,0,0,1-4.317-3.2,5.822,5.822,0,0,0,.872.071,4.883,4.883,0,0,0,1.215-.157,4.617,4.617,0,0,1-3.7-4.531V7.935A4.65,4.65,0,0,0,3,8.521,4.624,4.624,0,0,1,1.572,2.346a13.123,13.123,0,0,0,9.519,4.831,5.212,5.212,0,0,1-.114-1.058,4.621,4.621,0,0,1,7.99-3.159A9.089,9.089,0,0,0,21.9,1.846a4.6,4.6,0,0,1-2.03,2.544,9.255,9.255,0,0,0,2.659-.715,9.924,9.924,0,0,1-2.315,2.387Z"
          transform="translate(6.758 6.244)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
export const YoutubeIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <defs>
        <filter
          id="Ellipse_52"
          x="0"
          y="0"
          width="52"
          height="52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="youtube" transform="translate(8.737 5.711)">
        <g
          transform="matrix(1, 0, 0, 1, -8.74, -5.71)"
          filter="url(#Ellipse_52)"
        >
          <circle
            id="Ellipse_52-2"
            data-name="Ellipse 52"
            cx="17"
            cy="17"
            r="17"
            transform="translate(9 6)"
            fill="#fff"
          />
        </g>
        <path
          id="Icon_awesome-youtube"
          data-name="Icon awesome-youtube"
          d="M23.993,4.643a3.019,3.019,0,0,0-2.124-2.138C19.995,2,12.481,2,12.481,2s-7.514,0-9.388.505A3.019,3.019,0,0,0,.969,4.643a31.672,31.672,0,0,0-.5,5.821,31.672,31.672,0,0,0,.5,5.821,2.974,2.974,0,0,0,2.124,2.1c1.874.505,9.388.505,9.388.505s7.514,0,9.388-.505a2.974,2.974,0,0,0,2.124-2.1,31.672,31.672,0,0,0,.5-5.821A31.672,31.672,0,0,0,23.993,4.643ZM10.023,14.037V6.892l6.28,3.573-6.28,3.573Z"
          transform="translate(5.034 6.447)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
export const StudentsIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="83"
      viewBox="0 0 83 83"
      className="svg-icon"
    >
      <defs>
        <filter
          id="Path_6280"
          x="0"
          y="0"
          width="83"
          height="83"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5.5" result="blur" />
          <feFlood flood-color="#cc171d" floodOpacity="0.122" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="students" transform="translate(-124.735 -415.735)">
        <g
          transform="matrix(1, 0, 0, 1, 124.74, 415.74)"
          filter="url(#Path_6280)"
        >
          <path
            id="Path_6280-2"
            data-name="Path 6280"
            d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z"
            transform="translate(16.5 14.5)"
            fill="#fff"
          />
        </g>
        <g
          id="Group_5174"
          data-name="Group 5174"
          transform="translate(156.433 439.277)"
        >
          <g id="noun-student-3383255">
            <path
              id="Path_6065"
              data-name="Path 6065"
              d="M194.938,23.332a.448.448,0,0,0-.146.029l-9.2,3.546h0a.445.445,0,0,0,0,.832l2.653,1.017v4.912h0a1.989,1.989,0,0,0,.967,3.374,5.8,5.8,0,0,0,3.274,4.418v1.3a.839.839,0,0,1-.481.758l-.863.41a1.422,1.422,0,0,1-.446.126,2.727,2.727,0,0,0-1.457.63,1.878,1.878,0,0,0-.257.267l-1.821.861a3.521,3.521,0,0,0-2.012,3.183v3.8A1.053,1.053,0,0,0,186.2,53.85h17.5a1.053,1.053,0,0,0,1.052-1.053v-3.8a3.521,3.521,0,0,0-2.015-3.183l-1.819-.861a1.878,1.878,0,0,0-.257-.267,2.729,2.729,0,0,0-1.457-.63,1.421,1.421,0,0,1-.446-.126l-.865-.41h0a.84.84,0,0,1-.48-.758v-1.3a5.8,5.8,0,0,0,3.275-4.418,1.989,1.989,0,0,0,.059-3.875v-.15a.452.452,0,0,0,.451.007.489.489,0,0,0,.455-.487V28.757l1.331-.51v2.446a1.138,1.138,0,1,0,.459,0V28.071l.863-.331a.446.446,0,0,0,0-.832l-9.2-3.546h0a.443.443,0,0,0-.175-.029Zm.017.461,9.156,3.53-9.156,3.51-9.157-3.51Zm-6.245,5.141,6.085,2.332h0a.443.443,0,0,0,.319,0l6.083-2.332v1.688h0a25.191,25.191,0,0,1-12.488,0Zm0,2.163h0a25.651,25.651,0,0,0,8.164.7,5.273,5.273,0,0,1-5.541.658,1.526,1.526,0,0,0-2,.677,1.993,1.993,0,0,0-.62.2Zm12.488,0v1.438a.029.029,0,0,1-.029.028A2.275,2.275,0,0,1,199.1,31.53q1.056-.173,2.095-.433Zm-2.58.508a2.779,2.779,0,0,0,1.674,1.327v3.282a5.337,5.337,0,0,1-10.674,0V33.836a1.066,1.066,0,0,1,1.519-.965,5.734,5.734,0,0,0,6.5-1.144q.49-.052.977-.123Zm-9.46,2.04v2.569c0,.114.012.227.023.34a1.528,1.528,0,0,1-.023-2.908Zm11.594,0h0a1.528,1.528,0,0,1-.023,2.908q.016-.169.023-.34Zm-7.8,8.009h0a5.8,5.8,0,0,0,4.006,0v1.1a1.3,1.3,0,0,0,.744,1.175l.259.122-.44,2.541h0a7.56,7.56,0,0,1-5.129,0l-.44-2.541.259-.122h0a1.3,1.3,0,0,0,.743-1.175Zm-1.432,2.6,1.436,8.3-3.682-5.671a1.415,1.415,0,0,1,.271-1.851,2.269,2.269,0,0,1,1.211-.523,1.876,1.876,0,0,0,.59-.169Zm6.872,0,.175.082a1.869,1.869,0,0,0,.589.169,2.268,2.268,0,0,1,1.211.523,1.415,1.415,0,0,1,.271,1.851l-3.682,5.671Zm-9.743,1.36h0a1.875,1.875,0,0,0,.236,1.516l4.063,6.255h-6.741a.593.593,0,0,1-.592-.593v-3.8a3.06,3.06,0,0,1,1.751-2.766Zm12.615,0,1.283.608h0a3.061,3.061,0,0,1,1.751,2.766v3.8a.593.593,0,0,1-.593.593h-6.74l4.063-6.255h0a1.875,1.875,0,0,0,.236-1.516Zm-8.784,1.494h0a8.02,8.02,0,0,0,4.954,0l-1.086,6.277h-2.782Z"
              transform="translate(-185.152 -23.332)"
              fill={fill}
              stroke={fill}
              stroke-width="0.2"
            />
            <path
              id="Path_6066"
              data-name="Path 6066"
              d="M385.871,213.949a.541.541,0,1,0-.156.386A.54.54,0,0,0,385.871,213.949Z"
              transform="translate(-372.921 -202.103)"
              fill={fill}
              stroke={fill}
              stroke-width="0.2"
            />
            <path
              id="Path_6067"
              data-name="Path 6067"
              d="M298.171,213.949a.54.54,0,1,0-.156.386A.54.54,0,0,0,298.171,213.949Z"
              transform="translate(-290.435 -202.103)"
              fill={fill}
              stroke={fill}
              stroke-width="0.2"
            />
            <path
              id="Path_6068"
              data-name="Path 6068"
              d="M321.425,281.177a2.244,2.244,0,0,0,2.716,0,.23.23,0,0,1,.278.366,2.7,2.7,0,0,1-3.273,0,.23.23,0,0,1,.278-.366Z"
              transform="translate(-312.98 -265.807)"
              fill={fill}
              stroke={fill}
              stroke-width="0.2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
export const InstructosIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="83"
      viewBox="0 0 83 83"
    >
      <defs>
        <filter
          id="Ellipse_170"
          x="0"
          y="0"
          width="83"
          height="83"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5.5" result="blur" />
          <feFlood flood-color="#cc171d" floodOpacity="0.122" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="instructor" transform="translate(-251.917 -416.917)">
        <g
          transform="matrix(1, 0, 0, 1, 251.92, 416.92)"
          filter="url(#Ellipse_170)"
        >
          <circle
            id="Ellipse_170-2"
            data-name="Ellipse 170"
            cx="25"
            cy="25"
            r="25"
            transform="translate(16.5 14.5)"
            fill="#fff"
          />
        </g>
        <g
          id="Group_5175"
          data-name="Group 5175"
          transform="translate(279.142 440.424)"
        >
          <path
            id="Path_6119"
            data-name="Path 6119"
            d="M162.61,59.695a7.746,7.746,0,0,0-3.648-5.365,35.512,35.512,0,0,0-5.287-2.6,15.3,15.3,0,0,0-.849-1.3,6.942,6.942,0,0,0,2.577-5.151,1.826,1.826,0,0,0,.014-3.649V37.919c0-.153-.009-.3-.024-.453-.421-4.462-6.025-5.223-10.118-3.951a4.518,4.518,0,0,0-.928.412c-.025.014-.051.027-.075.041l0,0a4.592,4.592,0,0,0-2.186,3.948c0,.052,0,3.778,0,3.728a1.822,1.822,0,0,0,.006,3.62,6.666,6.666,0,0,0,2.079,4.763,6.8,6.8,0,0,0,.533.455c-.2.279-.5.719-.83,1.281a36.128,36.128,0,0,0-5.194,2.566,7.748,7.748,0,0,0-3.648,5.365.374.374,0,0,0,.157.368,23.646,23.646,0,0,0,13.555,4.587.352.352,0,0,0,.074.015.362.362,0,0,0,.092-.019,24.911,24.911,0,0,0,13.538-4.58.374.374,0,0,0,.163-.371Zm-8.155-3.938a5.075,5.075,0,0,0-4.042,1.537,26.256,26.256,0,0,0,2.1-6.009A12.23,12.23,0,0,1,154.455,55.757Zm-.9-12.811a2.137,2.137,0,0,1-.517,1.666,1.3,1.3,0,0,1-1.081.353,1.964,1.964,0,0,1-2.015-1.876c0-.05.007-.076,0-.026a1.425,1.425,0,0,1,1.012-.974,3.448,3.448,0,0,1,1.311-.138c.625.046.981.229,1.165.6,0,.006,0,.013.005.019l0,0a1.48,1.48,0,0,1,.112.368ZM152.323,41.2a4.2,4.2,0,0,0-1.594.172,2.138,2.138,0,0,0-1.378,1.2,1.147,1.147,0,0,0-1.23-.062,2.14,2.14,0,0,0-1.348-1.134,4.2,4.2,0,0,0-1.594-.172,2.108,2.108,0,0,0-1.571.713l-.776-.4v-.3l1.6-1.99a1.979,1.979,0,0,1,1.553-.747h5.546a1.979,1.979,0,0,1,1.554.748L154.67,41.2v.322l-.768.395a2.123,2.123,0,0,0-1.579-.71Zm-8.256,1.369h0v0c.185-.392.542-.575,1.167-.621q.152-.011.3-.011a3.311,3.311,0,0,1,1.012.149,1.425,1.425,0,0,1,1.012.975.128.128,0,0,1,0,.034,1.964,1.964,0,0,1-2.014,1.867,1.31,1.31,0,0,1-1.081-.353,2.12,2.12,0,0,1-.521-1.63,1.562,1.562,0,0,1,.124-.409ZM145.5,34.23a10.922,10.922,0,0,1,3.252-.5c3.125,0,5.917,1.065,5.917,4.19V40l-1-1.24a2.724,2.724,0,0,0-2.138-1.029h-5.546a2.722,2.722,0,0,0-2.137,1.028l-1.017,1.264V37.919a3.9,3.9,0,0,1,1.8-3.273,3.623,3.623,0,0,1,.87-.416Zm10.916,9.224a1.079,1.079,0,0,1-1,1.075V42.38A1.079,1.079,0,0,1,156.417,43.454Zm-15.192,0a1.087,1.087,0,0,1,.861-1.052v2.1a1.09,1.09,0,0,1-.861-1.049Zm1.609,1.7V42.359l.44.226a2.67,2.67,0,0,0-.072.309,2.848,2.848,0,0,0,.739,2.253,2.052,2.052,0,0,0,1.671.564,2.686,2.686,0,0,0,2.667-2.4c.317-.3.562-.28.891.07a.35.35,0,0,0,.078.054,2.679,2.679,0,0,0,2.644,2.272c.076.007.152.01.226.01a2.01,2.01,0,0,0,1.445-.574,2.868,2.868,0,0,0,.735-2.29,2.61,2.61,0,0,0-.061-.273l.434-.223v2.613a6.035,6.035,0,0,1-5.632,6.134,5.931,5.931,0,0,1-6.2-5.954Zm6.24,6.7a6.441,6.441,0,0,0,2.7-.737,33.571,33.571,0,0,1-2.991,7.89,34.043,34.043,0,0,1-2.976-7.834,6.585,6.585,0,0,0,3.266.681Zm-4.016-.574a26.306,26.306,0,0,0,2.1,6.015,5.339,5.339,0,0,0-3.587-1.566,3.746,3.746,0,0,0-.46.028,12.311,12.311,0,0,1,1.946-4.476Zm-5.988,3.688a34.06,34.06,0,0,1,4.255-2.166,10.465,10.465,0,0,0-1.03,3.4.376.376,0,0,0,.5.389c.114-.042,2.818-.977,5.637,3.43,0,0,.006,0,.008.008v3.861a22.827,22.827,0,0,1-12.632-4.3,7.009,7.009,0,0,1,3.258-4.614Zm10.123,8.912V59.924c2.8-4.3,5.462-3.38,5.572-3.338a.374.374,0,0,0,.507-.387,10.474,10.474,0,0,0-1.045-3.434,34.293,34.293,0,0,1,4.346,2.2,7.011,7.011,0,0,1,3.256,4.609,24.177,24.177,0,0,1-12.637,4.3Z"
            transform="translate(-135.026 -32.961)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
          <path
            id="Path_6120"
            data-name="Path 6120"
            d="M336.373,242.7a.374.374,0,1,0-.44-.605.541.541,0,0,1-.638,0,.374.374,0,0,0-.44.605A1.286,1.286,0,0,0,336.373,242.7Z"
            transform="translate(-321.888 -228.604)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
          <path
            id="Path_6121"
            data-name="Path 6121"
            d="M315.65,267.717a.375.375,0,0,0-.529-.008,2.579,2.579,0,0,1-3.612,0,.374.374,0,1,0-.522.537,3.324,3.324,0,0,0,4.655,0A.374.374,0,0,0,315.65,267.717Z"
            transform="translate(-299.59 -252.547)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
          <path
            id="Path_6122"
            data-name="Path 6122"
            d="M286.473,188.515a.5.5,0,0,1-.294-.9,1.41,1.41,0,0,1,1.666,0,.5.5,0,1,1-.588.807.415.415,0,0,0-.491,0A.494.494,0,0,1,286.473,188.515Z"
            transform="translate(-276.287 -177.434)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
          <path
            id="Path_6123"
            data-name="Path 6123"
            d="M381.388,187.623a1.411,1.411,0,0,0-1.666,0,.5.5,0,0,0,.588.807.415.415,0,0,1,.491,0,.5.5,0,1,0,.587-.807Z"
            transform="translate(-363.829 -177.444)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
        </g>
      </g>
    </svg>
  );
};
export const CoursesIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="83"
      viewBox="0 0 83 83"
    >
      <defs>
        <filter
          id="Path_6176"
          x="0"
          y="0"
          width="83"
          height="83"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5.5" result="blur" />
          <feFlood flood-color="#cc171d" floodOpacity="0.122" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Courses" transform="translate(-376.5 -416.5)">
        <g
          transform="matrix(1, 0, 0, 1, 376.5, 416.5)"
          filter="url(#Path_6176)"
        >
          <path
            id="Path_6176-2"
            data-name="Path 6176"
            d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z"
            transform="translate(16.5 14.5)"
            fill="#fff"
          />
        </g>
        <g
          id="Group_5173"
          data-name="Group 5173"
          transform="translate(403.189 441.224)"
        >
          <path
            id="Path_6030"
            data-name="Path 6030"
            d="M144.944,61.189l-1.41-3.664a.369.369,0,0,0-.483-.21l-15.7,6.355A1.037,1.037,0,0,0,126.782,65l8.147,21.184a1.015,1.015,0,0,0,.545.571,1,1,0,0,0,.4.083.988.988,0,0,0,.372-.072L139,85.67l15.375,1.049h.025a.369.369,0,0,0,.369-.345l1.559-24.038a.369.369,0,0,0-.343-.392Zm-.813-.055-4.983-.34a1,1,0,0,0-.728.247,1.026,1.026,0,0,0-.349.712l-.051.791-4.487,1.816a.369.369,0,0,0-.206.475l2.155,5.6a.372.372,0,0,0,.2.206.368.368,0,0,0,.286,0l1.572-.636-.615,9.474-6.287-16.347,12.347-5Zm-6.542,23.7a.285.285,0,0,1-.255-.309L138.807,61.8a.293.293,0,0,1,.1-.2.263.263,0,0,1,.174-.066h.018l2.5.17L140.083,85Zm0-15.64-1.553.628-1.889-4.913,3.821-1.546Zm-1.618,16.888a.261.261,0,0,1-.2,0,.279.279,0,0,1-.15-.159l-8.147-21.184a.3.3,0,0,1,.156-.381l2.321-.939,6.829,17.756a.341.341,0,0,0,.03.053l-.211,3.251a1.029,1.029,0,0,0,.745,1.06Zm18.091-.124-13.241-.9,1.511-23.3,13.241.9Z"
            transform="translate(-126.713 -57.288)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
          <path
            id="Path_6031"
            data-name="Path 6031"
            d="M384.015,167.769l8.83.6h.025a.369.369,0,0,0,.369-.345l.389-6.009a.369.369,0,0,0-.343-.392l-8.83-.6a.39.39,0,0,0-.269.09.368.368,0,0,0-.125.254l-.39,6.009A.37.37,0,0,0,384.015,167.769Zm.76-5.984,8.093.552-.342,5.272-8.093-.552Z"
            transform="translate(-366.722 -154.181)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
          <path
            id="Path_6032"
            data-name="Path 6032"
            d="M381.857,286.354l8.83.6h.025a.369.369,0,0,0,.025-.738l-8.829-.6a.369.369,0,0,0-.05.737Z"
            transform="translate(-364.706 -270.555)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
          <path
            id="Path_6033"
            data-name="Path 6033"
            d="M379.678,319.847l8.829.6h.026a.369.369,0,0,0,.025-.738l-8.829-.6a.375.375,0,0,0-.393.344A.369.369,0,0,0,379.678,319.847Z"
            transform="translate(-362.671 -301.84)"
            fill={fill}
            stroke={fill}
            stroke-width="0.2"
          />
        </g>
      </g>
    </svg>
  );
};
export const ClassesIcons = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="83.037"
      viewBox="0 0 83.037 83.037"
    >
      <defs>
        <filter
          id="Path_6177"
          x="0"
          y="0"
          width="83.037"
          height="83.037"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="5.5" result="blur" />
          <feFlood flood-color="#cc171d" floodOpacity="0.122" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="classes" transform="translate(-506.5 -416.5)">
        <g
          transform="matrix(1, 0, 0, 1, 506.5, 416.5)"
          filter="url(#Path_6177)"
        >
          <path
            id="Path_6177-2"
            data-name="Path 6177"
            d="M25.019,0A25.019,25.019,0,1,1,0,25.019,25.019,25.019,0,0,1,25.019,0Z"
            transform="translate(16.5 14.5)"
            fill="#fff"
          />
        </g>
        <g
          id="Group_5176"
          data-name="Group 5176"
          transform="translate(534.222 444.062)"
        >
          <path
            id="Path_6165"
            data-name="Path 6165"
            d="M114.634,55.259h-1.38v-2.3a.46.46,0,0,0-.46-.46h-7.818c-1.782,0-3.047.54-3.679,1.524-.632-.984-1.9-1.524-3.679-1.524H89.8a.46.46,0,0,0-.46.46v2.3H87.96a.46.46,0,0,0-.46.46v18.4a.46.46,0,0,0,.46.46h9.9a5.146,5.146,0,0,0,3.552,1.84,4.323,4.323,0,0,0,3.321-1.84h9.9a.46.46,0,0,0,.46-.46v-18.4a.46.46,0,0,0-.46-.46Zm-9.658-1.84h7.358V70.9h-7.358a4.717,4.717,0,0,0-3.219.979V55.719c0-1.526,1.083-2.3,3.219-2.3Zm-14.717,0h7.358c2.136,0,3.219.774,3.219,2.3V71.875a4.717,4.717,0,0,0-3.219-.979H90.259Zm23.915,20.235h-9.658a.46.46,0,0,0-.363.178,3.58,3.58,0,0,1-2.732,1.662h0a4.466,4.466,0,0,1-2.976-1.663h0a.459.459,0,0,0-.362-.177H88.42V56.179h.92V71.356a.46.46,0,0,0,.46.46h7.818c2.136,0,3.219.774,3.219,2.3a.46.46,0,1,0,.92,0c0-1.526,1.083-2.3,3.219-2.3h7.818a.46.46,0,0,0,.46-.46V56.179h.92Z"
            transform="translate(-87.5 -52.5)"
            fill={fill}
          />
          <path
            id="Path_6166"
            data-name="Path 6166"
            d="M175.46,123.42h5.979a.46.46,0,1,0,0-.92H175.46a.46.46,0,0,0,0,.92Z"
            transform="translate(-170.401 -118.821)"
            fill={fill}
          />
          <path
            id="Path_6167"
            data-name="Path 6167"
            d="M175.46,175.92h5.979a.46.46,0,1,0,0-.92H175.46a.46.46,0,0,0,0,.92Z"
            transform="translate(-170.401 -168.561)"
            fill={fill}
          />
          <path
            id="Path_6168"
            data-name="Path 6168"
            d="M175.46,228.42h5.979a.46.46,0,1,0,0-.92H175.46a.46.46,0,0,0,0,.92Z"
            transform="translate(-170.401 -218.302)"
            fill={fill}
          />
          <path
            id="Path_6169"
            data-name="Path 6169"
            d="M175.46,280.92h5.979a.46.46,0,1,0,0-.92H175.46a.46.46,0,0,0,0,.92Z"
            transform="translate(-170.401 -268.043)"
            fill={fill}
          />
          <path
            id="Path_6170"
            data-name="Path 6170"
            d="M175.46,333.42h5.979a.46.46,0,1,0,0-.92H175.46a.46.46,0,0,0,0,.92Z"
            transform="translate(-170.401 -317.783)"
            fill={fill}
          />
          <path
            id="Path_6171"
            data-name="Path 6171"
            d="M394.21,123.42h5.979a.46.46,0,0,0,0-.92H394.21a.46.46,0,1,0,0,.92Z"
            transform="translate(-377.653 -118.821)"
            fill={fill}
          />
          <path
            id="Path_6172"
            data-name="Path 6172"
            d="M394.21,175.92h5.979a.46.46,0,1,0,0-.92H394.21a.46.46,0,1,0,0,.92Z"
            transform="translate(-377.653 -168.561)"
            fill={fill}
          />
          <path
            id="Path_6173"
            data-name="Path 6173"
            d="M394.21,228.42h5.979a.46.46,0,1,0,0-.92H394.21a.46.46,0,1,0,0,.92Z"
            transform="translate(-377.653 -218.302)"
            fill={fill}
          />
          <path
            id="Path_6174"
            data-name="Path 6174"
            d="M394.21,280.92h5.979a.46.46,0,1,0,0-.92H394.21a.46.46,0,1,0,0,.92Z"
            transform="translate(-377.653 -268.043)"
            fill={fill}
          />
          <path
            id="Path_6175"
            data-name="Path 6175"
            d="M394.21,333.42h5.979a.46.46,0,0,0,0-.92H394.21a.46.46,0,1,0,0,.92Z"
            transform="translate(-377.653 -317.783)"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export const SurveyScalingIcon = (
  name,
  style = {
    width: '100%',
    height: '100%',
    border: '',
    fillColor: '',
  },

  checked = false,
  thin = 0,
) => {
  const EMOJI_ICON = {
    bad: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_2"
        data-name="Layer 2"
        viewBox="0 0 240.87 240.87"
        width={style.width}
        height={style.height}
      >
        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html: `.cls-1-bad, .cls-2-good-bad, .cls-3-bad, .cls-4-bad {stroke-width: ${thin}} .cls-2-bad {fill: ${
                checked ? style.border : '#d31b3d'
              };} 
                .cls-3-bad {fill:  ${
                  checked ? style.fillColor : '#e62a3f'
                }} .cls-4-bad {  fill: ${
                checked ? style.fillColor : '#d8d8d8'
              } }  `,
            }}
          />
        </defs>
        <g id="Capa_1" data-name="Capa 1">
          <g>
            <path
              className="cls-4-bad"
              d="m120.44,240.87c66.51,0,120.44-53.92,120.44-120.44S186.95,0,120.44,0,0,53.92,0,120.44s53.92,120.44,120.44,120.44Z"
            />
            <path
              className="cls-3-bad"
              d="m120.43,135.38c6.96,0,13.51,1.38,19.3,3.77,9.59-6.34,18.03-14.23,25.09-23.27l-12.59-5.81c-1.14-.53-1.88-1.66-1.9-2.91-.02-1.26.68-2.41,1.8-2.97l27.38-13.69c4.96-12.25,7.75-25.62,7.75-39.65,0-4.45-.36-8.81-.9-13.11-18.1-14.45-40.99-23.14-65.95-23.14C61.98,14.59,14.59,61.98,14.59,120.44c0,4.45.36,8.81.9,13.11,18.04,14.4,40.85,23.08,65.72,23.13,6.23-12.46,21.45-21.3,39.23-21.3Zm-60.01-13.57c-.76-1.64-.04-3.58,1.6-4.33l22.73-10.49-22.82-11.41c-1.61-.81-2.27-2.77-1.46-4.38.81-1.61,2.77-2.26,4.38-1.46l28.89,14.45c1.12.56,1.83,1.72,1.8,2.97-.02,1.25-.75,2.39-1.9,2.91l-28.89,13.34-1.36.3c-1.23,0-2.42-.7-2.97-1.9Z"
            />
            <path
              className="cls-2-bad"
              d="m15.49,133.56c2.37,19.1,9.85,36.58,20.97,51.13.37.49.72,1,1.11,1.48,1.44,1.82,2.99,3.56,4.54,5.28.65.71,1.28,1.44,1.94,2.14,1.45,1.52,2.98,2.97,4.52,4.4.87.81,1.74,1.62,2.64,2.4,1.47,1.27,2.98,2.49,4.52,3.68,1.08.84,2.17,1.66,3.28,2.45,1.48,1.06,2.98,2.08,4.51,3.06,1.27.81,2.56,1.59,3.87,2.35,1.48.86,2.97,1.7,4.5,2.49,1.45.75,2.94,1.45,4.43,2.14,1.47.68,2.95,1.36,4.46,1.97,1.64.66,3.31,1.24,4.99,1.83,1.45.5,2.88,1.03,4.35,1.47,1.85.55,3.74,1,5.63,1.45,1.38.33,2.74.71,4.14.98,2.17.43,4.38.71,6.59,1.01,1.18.16,2.34.38,3.53.5,3.4.33,6.84.52,10.33.52.03,0,.06,0,.09,0,58.46,0,105.85-47.39,105.85-105.85,0,0,0,0,0-.01,0-3.32-.2-6.59-.5-9.83-.05-.51-.08-1.02-.13-1.53-.33-3.04-.79-6.03-1.37-8.99-.13-.66-.26-1.31-.4-1.97-.62-2.87-1.33-5.7-2.18-8.48-.2-.65-.42-1.29-.63-1.93-.81-2.48-1.7-4.93-2.68-7.33-.3-.73-.6-1.45-.92-2.17-.97-2.23-2.03-4.4-3.15-6.55-.46-.88-.91-1.77-1.39-2.63-1.2-2.14-2.48-4.23-3.81-6.28-.67-1.02-1.35-2.02-2.05-3.02-1.28-1.81-2.6-3.6-3.98-5.32-.89-1.11-1.83-2.19-2.76-3.27-.97-1.11-1.96-2.2-2.97-3.26-1.45-1.54-2.95-3.03-4.49-4.48-1-.94-2-1.86-3.03-2.76-1.13-.98-2.26-1.96-3.42-2.89,0,0,0,0,0,0h0c.53,4.31.9,8.66.9,13.11,0,14.03-2.79,27.39-7.75,39.65l1.51-.76c1.62-.8,3.58-.15,4.38,1.46.81,1.61.15,3.57-1.46,4.38l-8.83,4.41c-1.91,3.64-4,7.17-6.31,10.54l15.05,6.94c1.64.75,2.35,2.69,1.6,4.33-.55,1.2-1.73,1.9-2.97,1.9l-1.36-.3-16.31-7.53c-7.06,9.04-15.5,16.93-25.09,23.27,13.62,5.62,22.97,16.97,22.97,30.05,0,1.8-1.46,3.27-3.27,3.27s-3.27-1.46-3.27-3.27c0-11.81-9.9-21.86-23.67-25.65-13.07,7.22-27.84,11.66-43.55,12.77-2.71,3.84-4.25,8.23-4.25,12.88,0,1.8-1.46,3.27-3.27,3.27s-3.27-1.46-3.27-3.27c0-4.42,1.1-8.64,3.04-12.51-24.87-.05-47.68-8.73-65.72-23.13h0s0,0,0,0Z"
            />
            <path
              className="cls-3-bad"
              d="m88.95,156.31c15.7-1.11,30.48-5.55,43.55-12.77-3.78-1.04-7.83-1.63-12.06-1.63-13.6,0-25.45,5.84-31.48,14.4Z"
            />
            <path
              className="cls-3-bad"
              d="m168.83,110.53c2.31-3.37,4.4-6.9,6.31-10.54l-13.99,7,7.68,3.55Z"
            />
            <path
              className="cls-1-bad"
              d="m93.65,110.06c1.14-.53,1.88-1.66,1.9-2.91.02-1.26-.68-2.41-1.8-2.97l-28.89-14.45c-1.61-.8-3.57-.16-4.38,1.46-.81,1.61-.15,3.57,1.46,4.38l22.82,11.41-22.73,10.49c-1.64.75-2.35,2.69-1.6,4.33.55,1.2,1.73,1.9,2.97,1.9l1.36-.3,28.89-13.34Z"
            />
            <path
              className="cls-1-bad"
              d="m150.35,107.15c.02,1.25.75,2.39,1.9,2.91l12.59,5.81,16.31,7.53,1.36.3c1.23,0,2.42-.7,2.97-1.9.76-1.64.04-3.58-1.6-4.33l-15.05-6.94-7.68-3.55,13.99-7,8.83-4.41c1.61-.81,2.27-2.77,1.46-4.38-.8-1.61-2.76-2.26-4.38-1.46l-1.51.76-27.38,13.69c-1.12.56-1.83,1.72-1.8,2.97Z"
            />
            <path
              className="cls-1-bad"
              d="m81.21,156.68c-1.94,3.88-3.04,8.09-3.04,12.51,0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27c0-4.66,1.54-9.04,4.25-12.88,6.03-8.56,17.88-14.4,31.48-14.4,4.24,0,8.29.6,12.06,1.63,13.78,3.79,23.67,13.84,23.67,25.65,0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27c0-13.08-9.35-24.42-22.97-30.05-5.79-2.39-12.34-3.77-19.3-3.77-17.78,0-32.99,8.84-39.23,21.3Z"
            />
          </g>
        </g>
      </svg>
    ),
    notBad: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_2"
        data-name="Layer 2"
        viewBox="0 0 240.87 240.87"
        width={style.width}
        height={style.height}
      >
        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html: `   .cls-1-notbad {fill: ${
                checked ? style.fillColor : '#f6c218'
              };  }
                .cls-1-notbad, .cls-2-notbad, .cls-3-notbad, .cls-4-notbad { stroke-width: ${thin} }
                 .cls-3-notbad { fill: ${
                   checked ? style.fillColor : '#ffdf07'
                 }; }  .cls-4-notbad { fill: ${
                checked ? style.border : '#d8d8d8'
              } ; }      `,
            }}
          />
        </defs>
        <g id="Capa_1" data-name="Capa 1">
          <g>
            <path
              className="cls-4-notbad"
              d="m120.44,240.87c66.51,0,120.44-53.92,120.44-120.44S186.95,0,120.44,0,0,53.92,0,120.44s53.92,120.44,120.44,120.44Z"
            />
            <path
              className="cls-1-notbad"
              d="m15.49,133.56c2.37,19.1,9.85,36.58,20.97,51.13.37.49.73,1,1.11,1.48,1.44,1.82,2.99,3.56,4.54,5.28.65.71,1.28,1.44,1.94,2.14,1.45,1.52,2.98,2.97,4.52,4.4.87.81,1.74,1.62,2.64,2.4,1.47,1.27,2.98,2.49,4.52,3.68,1.08.84,2.17,1.66,3.28,2.45,1.48,1.06,2.98,2.08,4.51,3.06,1.27.81,2.56,1.59,3.87,2.35,1.48.86,2.97,1.7,4.5,2.49,1.45.75,2.94,1.45,4.43,2.14,1.47.68,2.95,1.36,4.46,1.97,1.64.66,3.31,1.24,4.99,1.83,1.45.5,2.88,1.03,4.35,1.47,1.85.55,3.74,1,5.63,1.45,1.38.33,2.74.71,4.14.98,2.17.43,4.38.71,6.59,1.01,1.18.16,2.34.38,3.53.5,3.4.33,6.84.52,10.33.52.03,0,.06,0,.09,0,58.46,0,105.85-47.39,105.85-105.85h0c0-3.34-.2-6.61-.5-9.85-.05-.51-.08-1.02-.13-1.53-.33-3.04-.79-6.03-1.37-8.99-.13-.66-.26-1.31-.4-1.97-.62-2.87-1.33-5.7-2.18-8.48-.2-.65-.42-1.29-.63-1.93-.81-2.48-1.7-4.93-2.68-7.33-.3-.73-.6-1.45-.92-2.17-.97-2.23-2.03-4.4-3.15-6.55-.46-.88-.91-1.77-1.39-2.63-1.2-2.14-2.48-4.23-3.81-6.28-.67-1.02-1.35-2.02-2.05-3.02-1.28-1.81-2.6-3.6-3.98-5.32-.89-1.11-1.83-2.19-2.76-3.27-.97-1.11-1.96-2.2-2.97-3.26-1.45-1.54-2.95-3.03-4.49-4.48-1-.94-2-1.86-3.03-2.76-1.13-.98-2.26-1.96-3.42-2.89,0,0,0,0,0,0h0c.53,4.31.9,8.66.9,13.11,0,19.11-5.14,36.99-14,52.47.02.35.07.69.07,1.05,0,7.1-4.01,12.85-8.96,12.85-.17,0-.34-.06-.51-.07-8.23,10.22-18.33,18.84-29.76,25.42h36.48c1.8,0,3.27,1.46,3.27,3.27s-1.46,3.27-3.27,3.27h-49.92c-12.15,4.86-25.37,7.6-39.25,7.6-24.96,0-47.86-8.69-65.95-23.14h0s0,0,0,0Z"
            />
            <path
              className="cls-3-notbad"
              d="m120.69,149.08h-46.48c-1.8,0-3.27-1.46-3.27-3.27s1.46-3.27,3.27-3.27h59.92c11.44-6.59,21.53-15.2,29.76-25.42-4.71-.39-8.45-5.93-8.45-12.78s4.01-12.85,8.96-12.85,8.51,5.2,8.89,11.8c8.86-15.48,14-33.35,14-52.47,0-4.45-.36-8.81-.9-13.11-18.1-14.45-40.99-23.14-65.95-23.14C61.98,14.59,14.59,61.98,14.59,120.44c0,4.45.36,8.81.9,13.11,18.1,14.45,40.99,23.14,65.95,23.14,13.88,0,27.1-2.75,39.25-7.6Z"
            />
            <path
              className="cls-2-notbad"
              d="m83.17,117.2c4.95,0,8.96-5.75,8.96-12.85s-4.01-12.85-8.96-12.85-8.96,5.75-8.96,12.85,4.01,12.85,8.96,12.85Z"
            />
            <path
              className="cls-2-notbad"
              d="m164.4,91.51c-4.95,0-8.96,5.75-8.96,12.85s3.74,12.39,8.45,12.78c.17.01.33.07.51.07,4.95,0,8.96-5.75,8.96-12.85,0-.36-.05-.7-.07-1.05-.38-6.6-4.19-11.8-8.89-11.8Z"
            />
            <path
              className="cls-2-notbad"
              d="m70.94,145.82c0,1.8,1.46,3.27,3.27,3.27h96.4c1.8,0,3.27-1.46,3.27-3.27s-1.46-3.27-3.27-3.27h-96.4c-1.8,0-3.27,1.46-3.27,3.27Z"
            />
          </g>
        </g>
      </svg>
    ),
    notGood: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_2"
        data-name="Layer 2"
        viewBox="0 0 240.87 240.87"
        width={style.width}
        height={style.height}
      >
        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html: `.cls-1-notgood {fill: ${
                checked ? style.fillColor : '#f3921a'
              }; } 
                .cls-1-notgood, .cls-2-notgood, .cls-3-notgood, .cls-4-notgood { stroke-width: ${thin} } 
                .cls-2-notgood { fill: ${
                  checked ? style.fillColor : '#f07f00'
                };  }  .cls-4-notgood { fill: ${
                checked ? style.border : '#d8d8d8'
              };  } `,
            }}
          />
        </defs>
        <g id="Capa_1" data-name="Capa 1">
          <g>
            <path
              className="cls-4-notgood"
              d="m120.44,240.87c66.51,0,120.44-53.92,120.44-120.44S186.95,0,120.44,0,0,53.92,0,120.44s53.92,120.44,120.44,120.44Z"
            />
            <path
              className="cls-1-notgood"
              d="m186.39,37.73c-18.1-14.45-40.99-23.14-65.95-23.14C61.98,14.59,14.59,61.98,14.59,120.44c0,4.45.37,8.81.91,13.12,18.09,14.44,40.99,23.13,65.94,23.13.1,0,.2-.01.3-.02,5.02-14.19,21.32-24.63,40.64-24.63,7.64,0,14.8,1.66,20.99,4.51,8.39-6.07,15.82-13.33,22.11-21.55-4.92-.06-8.89-5.78-8.89-12.84s4.01-12.85,8.96-12.85,8.62,5.34,8.9,12.07c8.18-15.02,12.83-32.24,12.83-50.54,0-4.45-.36-8.81-.9-13.11Z"
            />
            <path
              className="cls-2-notgood"
              d="m174.45,101.39c.01.26.06.51.06.78,0,7.1-4.01,12.85-8.96,12.85-.02,0-.05,0-.07-.01-6.28,8.22-13.72,15.47-22.11,21.55,12.69,5.84,21.27,16.78,21.27,29.31,0,1.8-1.46,3.27-3.27,3.27s-3.27-1.46-3.27-3.27c0-11.12-8.77-20.69-21.3-24.94-14.11,8.7-30.39,14.16-47.87,15.39-1.46,2.98-2.3,6.19-2.3,9.55,0,1.8-1.46,3.27-3.27,3.27s-3.27-1.46-3.27-3.27c0-3.19.59-6.26,1.63-9.19-.1,0-.2.02-.3.02-24.96,0-47.86-8.69-65.95-23.14,2.37,19.1,9.85,36.59,20.98,51.14.37.49.73,1,1.11,1.48,1.44,1.82,2.98,3.56,4.54,5.28.65.72,1.28,1.44,1.94,2.14,1.45,1.52,2.98,2.97,4.52,4.4.87.81,1.74,1.62,2.64,2.4,1.47,1.27,2.98,2.49,4.51,3.68,1.08.84,2.17,1.66,3.28,2.45,1.47,1.06,2.98,2.07,4.51,3.05,1.27.81,2.56,1.59,3.87,2.35,1.48.86,2.97,1.7,4.49,2.49,1.45.75,2.94,1.45,4.43,2.13,1.47.68,2.95,1.36,4.46,1.97,1.64.66,3.32,1.24,5,1.83,1.44.5,2.88,1.03,4.35,1.47,1.85.55,3.74,1,5.63,1.45,1.38.33,2.74.71,4.13.98,2.17.43,4.38.71,6.59,1.01,1.18.16,2.34.38,3.53.5,3.4.33,6.84.52,10.33.52.03,0,.06,0,.09,0,58.46,0,105.85-47.39,105.85-105.85h0c0-3.33-.2-6.61-.5-9.86-.05-.5-.08-1.01-.13-1.51-.33-3.04-.79-6.04-1.37-9-.13-.65-.26-1.3-.4-1.95-.62-2.87-1.34-5.71-2.18-8.49-.2-.65-.42-1.28-.63-1.92-.81-2.49-1.7-4.95-2.69-7.36-.3-.72-.59-1.44-.91-2.15-.98-2.23-2.04-4.41-3.16-6.56-.46-.88-.91-1.77-1.39-2.63-1.2-2.14-2.48-4.23-3.81-6.28-.67-1.02-1.35-2.02-2.05-3.02-1.28-1.81-2.6-3.6-3.98-5.32-.89-1.11-1.83-2.19-2.77-3.27-.96-1.11-1.95-2.19-2.96-3.26-1.45-1.54-2.95-3.03-4.49-4.48-1-.94-2.01-1.86-3.04-2.76-1.13-.98-2.26-1.96-3.42-2.89h0c.53,4.3.9,8.66.9,13.11,0,18.31-4.65,35.52-12.83,50.54Z"
            />
            <path
              className="cls-1-notgood"
              d="m88.95,156.31c17.48-1.23,33.75-6.69,47.87-15.39-4.42-1.5-9.3-2.35-14.44-2.35-15.3,0-28.35,7.39-33.43,17.73Z"
            />
            <path
              className="cls-3-notgood"
              d="m83.38,169.12c1.8,0,3.27-1.46,3.27-3.27,0-3.36.84-6.57,2.3-9.55,5.08-10.34,18.13-17.73,33.43-17.73,5.14,0,10.02.85,14.44,2.35,12.53,4.24,21.3,13.82,21.3,24.94,0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27c0-12.53-8.58-23.46-21.27-29.31-6.19-2.85-13.35-4.51-20.99-4.51-19.32,0-35.62,10.44-40.64,24.63-1.04,2.93-1.63,6-1.63,9.19,0,1.8,1.46,3.27,3.27,3.27Z"
            />
            <ellipse
              className="cls-3-notgood"
              cx="84.32"
              cy="102.17"
              rx="8.96"
              ry="12.85"
            />
            <path
              className="cls-3-notgood"
              d="m174.51,102.17c0-.27-.04-.52-.06-.78-.29-6.72-4.14-12.07-8.9-12.07s-8.96,5.75-8.96,12.85,3.97,12.78,8.89,12.84c.02,0,.05.01.07.01,4.95,0,8.96-5.75,8.96-12.85Z"
            />
          </g>
        </g>
      </svg>
    ),
    neutral: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_2"
        data-name="Layer 2"
        viewBox="0 0 240.87 240.87"
        width={style.width}
        height={style.height}
      >
        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html: `.cls-1-neutral {fill:  ${
                checked ? style.fillColor : '#77ccf4'
              }}
                .cls-1-neutral, .cls-2-neutral, .cls-3-neutral, 
                .cls-4-neutral {  stroke-width: ${thin} }  
                .cls-3-neutral {  fill:  ${
                  checked ? style.fillColor : '#36bde7'
                }; } 
                .cls-4-neutral {   fill:  ${
                  checked ? style.border : '#d8d8d8'
                }; } `,
            }}
          />
        </defs>
        <g id="Capa_1" data-name="Capa 1">
          <g>
            <path
              className="cls-4-neutral"
              d="m120.44,240.87c66.51,0,120.44-53.92,120.44-120.44S186.95,0,120.44,0,0,53.92,0,120.44s53.92,120.44,120.44,120.44Z"
            />
            <path
              className="cls-1-neutral"
              d="m81.98,156.66c-2.42-4.26-3.81-8.97-3.81-13.95,0-1.8,1.46-3.27,3.27-3.27s3.27,1.46,3.27,3.27c0,4.94,1.76,9.57,4.78,13.57,35.99-2.71,66.91-23.36,83.88-53.09-2.97-4.37-8.09-7.27-13.92-7.27-9.17,0-16.63,7.15-16.63,15.95,0,1.8-1.46,3.27-3.27,3.27s-3.27-1.46-3.27-3.27c0-12.39,10.39-22.48,23.16-22.48,6.84,0,12.93,2.95,17.18,7.54,6.77-13.95,10.67-29.54,10.67-46.08,0-4.45-.36-8.81-.9-13.11-18.1-14.45-40.99-23.14-65.95-23.14C61.98,14.59,14.59,61.98,14.59,120.44c0,4.45.36,8.81.9,13.11,18.1,14.45,40.99,23.14,65.95,23.14.18,0,.36-.03.54-.03Z"
            />
            <path
              className="cls-3-neutral"
              d="m15.49,133.56c2.37,19.1,9.85,36.58,20.97,51.13.37.49.73,1,1.11,1.48,1.44,1.82,2.98,3.56,4.54,5.28.65.72,1.28,1.44,1.94,2.14,1.45,1.52,2.98,2.97,4.52,4.4.87.81,1.74,1.62,2.64,2.4,1.47,1.27,2.98,2.49,4.51,3.68,1.08.84,2.17,1.66,3.28,2.45,1.47,1.06,2.98,2.07,4.51,3.05,1.27.81,2.56,1.59,3.87,2.35,1.48.86,2.97,1.7,4.49,2.49,1.45.75,2.94,1.45,4.43,2.13,1.47.68,2.95,1.36,4.46,1.97,1.64.66,3.32,1.24,5,1.83,1.44.5,2.88,1.03,4.35,1.47,1.85.55,3.74,1,5.63,1.45,1.38.33,2.74.71,4.13.98,2.17.43,4.38.71,6.59,1.01,1.18.16,2.34.38,3.53.5,3.4.33,6.84.52,10.33.52.03,0,.06,0,.09,0,58.46,0,105.85-47.39,105.85-105.85h0c0-3.33-.2-6.61-.5-9.86-.05-.5-.08-1.01-.13-1.51-.33-3.04-.79-6.04-1.37-9-.13-.65-.26-1.3-.4-1.95-.62-2.87-1.34-5.71-2.18-8.49-.2-.65-.42-1.28-.63-1.92-.81-2.49-1.7-4.95-2.69-7.36-.3-.72-.6-1.44-.91-2.15-.98-2.23-2.04-4.41-3.16-6.56-.46-.88-.91-1.77-1.39-2.63-1.2-2.14-2.48-4.23-3.81-6.28-.67-1.02-1.35-2.02-2.05-3.02-1.28-1.81-2.6-3.6-3.98-5.32-.89-1.11-1.83-2.19-2.77-3.27-.96-1.11-1.95-2.19-2.96-3.26-1.45-1.54-2.95-3.03-4.49-4.48-1-.94-2.01-1.86-3.04-2.76-1.13-.98-2.26-1.96-3.42-2.89h0c.53,4.3.9,8.66.9,13.11,0,16.54-3.9,32.14-10.67,46.08,3.68,3.98,5.99,9.18,5.99,14.94,0,1.8-1.46,3.27-3.27,3.27s-3.27-1.46-3.27-3.27c0-3.2-1.01-6.18-2.71-8.68-16.97,29.73-47.89,50.38-83.88,53.09,6.18,8.18,17.72,13.71,30.95,13.71,19.7,0,35.73-12.24,35.73-27.28,0-1.8,1.46-3.27,3.27-3.27s3.27,1.46,3.27,3.27c0,18.64-18.96,33.81-42.26,33.81-17.08,0-31.8-8.17-38.45-19.86-.18,0-.36.03-.54.03-24.96,0-47.86-8.69-65.95-23.14h0s0,0,0,0Z"
            />
            <path
              className="cls-2-neutral"
              d="m81.44,139.44c-1.8,0-3.27,1.46-3.27,3.27,0,4.98,1.39,9.69,3.81,13.95,6.66,11.7,21.37,19.86,38.45,19.86,23.3,0,42.26-15.17,42.26-33.81,0-1.8-1.46-3.27-3.27-3.27s-3.27,1.46-3.27,3.27c0,15.04-16.03,27.28-35.73,27.28-13.23,0-24.78-5.53-30.95-13.71-3.02-4-4.78-8.63-4.78-13.57,0-1.8-1.46-3.27-3.27-3.27Z"
            />
            <path
              className="cls-2-neutral"
              d="m99.85,111.87c0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27c0-12.39-10.39-22.48-23.16-22.48s-23.16,10.09-23.16,22.48c0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27c0-8.79,7.46-15.95,16.63-15.95s16.63,7.15,16.63,15.95Z"
            />
            <path
              className="cls-2-neutral"
              d="m159.43,89.39c-12.77,0-23.16,10.09-23.16,22.48,0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27c0-8.79,7.46-15.95,16.63-15.95,5.83,0,10.95,2.9,13.92,7.27,1.7,2.5,2.71,5.47,2.71,8.68,0,1.8,1.46,3.27,3.27,3.27s3.27-1.46,3.27-3.27c0-5.76-2.31-10.96-5.99-14.94-4.24-4.59-10.34-7.54-17.18-7.54Z"
            />
          </g>
        </g>
      </svg>
    ),
    good: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_2"
        data-name="Layer 2"
        viewBox="0 0 240.87 240.87"
        width={style.width}
        height={style.height}
      >
        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html: `.cls-1-good { fill:  ${
                checked ? style.fillColor : '#75aa2c'
              };} 
                .cls-1-good, .cls-2-good, .cls-3-good, .cls-4-good, .cls-5-good { stroke-width: ${thin} } 
                .cls-2-good { fill: ${checked ? style.fillColor : '#7eba28'} } 
                .cls-4-good {fill: #ea4f51; }
                .cls-5-good { fill: ${checked ? style.border : '#d8d8d8'}; }`,
            }}
          />
        </defs>
        <g id="Capa_1" data-name="Capa 1">
          <g>
            <path
              className="cls-5-good"
              d="m120.44,240.87c66.51,0,120.44-53.92,120.44-120.44S186.95,0,120.44,0,0,53.92,0,120.44s53.92,120.44,120.44,120.44Z"
            />
            <path
              className="cls-2-good"
              d="m87.96,156.36c-3.5-5.42-5.6-11.78-5.7-18.59h59.48c27.5-19.12,45.53-50.9,45.53-86.92,0-4.45-.36-8.81-.9-13.11-18.1-14.45-40.99-23.14-65.95-23.14C61.98,14.59,14.59,61.98,14.59,120.44c0,4.45.36,8.81.9,13.11,18.1,14.45,40.99,23.14,65.95,23.14,2.2,0,4.36-.2,6.53-.33Z"
            />
            <path
              className="cls-1-good"
              d="m15.49,133.56c2.37,19.1,9.85,36.58,20.97,51.13.37.49.72,1,1.11,1.48,1.44,1.82,2.99,3.56,4.54,5.28.65.71,1.28,1.44,1.94,2.14,1.45,1.52,2.98,2.97,4.52,4.4.87.81,1.74,1.62,2.64,2.4,1.47,1.27,2.98,2.49,4.52,3.68,1.08.84,2.17,1.66,3.28,2.45,1.48,1.06,2.98,2.08,4.51,3.06,1.27.81,2.56,1.59,3.87,2.35,1.48.86,2.97,1.7,4.5,2.49,1.45.75,2.94,1.45,4.43,2.14,1.47.68,2.95,1.36,4.46,1.97,1.64.66,3.31,1.24,4.99,1.83,1.45.5,2.88,1.03,4.35,1.47,1.85.55,3.74,1,5.63,1.45,1.38.33,2.74.71,4.14.98,2.17.43,4.38.71,6.59,1.01,1.18.16,2.34.38,3.53.5,3.4.33,6.84.52,10.33.52.03,0,.06,0,.09,0,58.46,0,105.85-47.39,105.85-105.85,0,0,0,0,0-.01,0-3.32-.2-6.59-.5-9.83-.05-.51-.08-1.02-.13-1.53-.33-3.04-.79-6.03-1.37-8.99-.13-.66-.26-1.31-.4-1.97-.62-2.87-1.33-5.7-2.18-8.48-.2-.65-.42-1.29-.63-1.93-.81-2.48-1.7-4.93-2.68-7.33-.3-.73-.6-1.45-.92-2.17-.97-2.23-2.03-4.4-3.15-6.55-.46-.88-.91-1.77-1.39-2.63-1.2-2.14-2.48-4.23-3.81-6.28-.67-1.02-1.35-2.02-2.05-3.02-1.28-1.81-2.6-3.6-3.98-5.32-.89-1.11-1.83-2.19-2.76-3.27-.97-1.11-1.96-2.2-2.97-3.26-1.45-1.54-2.95-3.03-4.49-4.48-1-.94-2-1.86-3.03-2.76-1.13-.98-2.26-1.96-3.42-2.89,0,0,0,0,0,0h0c.53,4.31.9,8.66.9,13.11,0,36.03-18.04,67.81-45.53,86.92h16.82c-.11,11.43-5.8,21.64-14.61,28.17-6.53,4.91-14.67,7.81-23.54,7.81s-17.01-2.9-23.54-7.81c-3.54-2.64-6.54-5.9-8.92-9.57-2.17.13-4.32.33-6.53.33-24.96,0-47.86-8.69-65.95-23.14h0s0,0,0,0Z"
            />
            <circle
              className="cls-3-good"
              cx="83.5"
              cy="102.53"
              r="10.68"
              transform="translate(-15.35 14.7) rotate(-9.22)"
            />
            <circle className="cls-3-good" cx="158.27" cy="102.53" r="10.68" />
            <path
              className="cls-3-good"
              d="m87.96,156.36c2.38,3.68,5.38,6.94,8.92,9.57,5.69-6.25,14.11-10.15,23.54-10.15s17.85,3.9,23.54,10.15c8.81-6.53,14.5-16.73,14.61-28.17h-76.31c.1,6.81,2.19,13.17,5.7,18.59Z"
            />
            <path
              className="cls-4-good"
              d="m96.88,165.93c6.53,4.91,14.67,7.81,23.54,7.81s17.01-2.9,23.54-7.81c-5.69-6.25-14.11-10.15-23.54-10.15s-17.85,3.9-23.54,10.15Z"
            />
          </g>
        </g>
      </svg>
    ),
  };
  return EMOJI_ICON[name || 'bad'];
};
